<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col md="6">
              <!-- .first_name -->
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.name')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-27"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('edu_contents.name')"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.duration')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="duration"
                  vid="duration"
                  rules="required"
                >
                  <cleave
                    id="time"
                    v-model="newItem.duration"
                    class="form-control"
                    :raw="false"
                    :options="time"
                    :placeholder="$t('edu_contents.duration')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.code')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  vid="code"
                  rules="required"
                >
                  <b-form-input
                    id="time"
                    v-model="newItem.code"
                    class="form-control"
                    type="text"
                    :placeholder="$t('edu_contents.code')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <!-- .last_name -->
              <b-form-group
                id="input-group-28"
                :label="$t('edu_contents.description')"
                label-for="input-28"
              >
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  vid="description"
                  rules="required"
                >
                  <ckeditor
                    :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                    name="textarea"
                    v-model="newItem.description"
                    rows="4"
                    :placeholder="$t('edu_contents.description')"
                  ></ckeditor>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row class="quiz" id="quiz" data-toggle="buttons">
            <b-col lg="3" v-for="item in types" :key="item.type" class="p-1">
              <b-button
                :variant="'outline-' + item.color"
                @click="selectedType(item)"
                block
                :class="{ active: item.type == newItem.type }"
              >
                <feather-icon :icon="item.icon" />
                {{ item.title }}</b-button
              ></b-col
            >
          </b-row>
          <hr />
          <b-row v-if="eduProgram.flixable == 1">
            <b-col md="12">
              <b-form-group>
                <h5>{{ $t("edu_contents.lecture_time") }}</h5>
                <flat-pickr
                  v-model="newItem.start_in"
                  class="form-control"
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <iframe
                v-if="
                  newItem.type == 'voice_lectures' ||
                  newItem.type == 'interactive_video_lectures'
                "
                ref="myIframe"
                :src="src"
                style="width: 100%; height: 800px"
                frameborder="0"
              ></iframe>
              <b-form-file
                v-else
                v-model="newItem.file"
                placeholder="اختيار ملف أو تسقطها هنا ..."
                drop-placeholder="إسقاط الملف هنا ..."
                :accept="accept"
                @change="previewImage($event)"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/EduContentController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { required } from "@validations";
import EduProgramsController from "@/Controllers/EduProgramsController";
import flatPickr from "vue-flatpickr-component";
import EduCoursesController from '@/Controllers/EduCoursesController';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    Cleave,
    flatPickr,
  },
  mounted() {
    // Here we have the object of iframe

    window.addEventListener("message", this.handleMessage);
    if (
      this.newItem.type == "voice_lectures" ||
      this.newItem.type == "interactive_video_lectures"
    ) {
      this.iframeWin = this.$refs.myIframe.contentWindow;
    }
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      

      accept: "",
      time: {
        time: true,
        timePattern: ["h", "m"],
      },
      src: "",
      iframeWin: {},
      file: {},
      course: {},
      eduProgram: {},
    };
  },
  async created() {
    this.types = new EduCoursesController().Types();

    let res = await new EduProgramsController().AssignOfficialExams(
      this.$route.params.eduProgramId
    );
    this.course = res.courses[0];
    this.eduProgram = res.eduProgram;
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.program_type = "course_programs";
      let ret = await new Controller(this.course.id).From(
        this.newItem,
        "FormData"
      );
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].dataProvider({});
        this.$parent.$parent.firstTab();
      }
    },
    handleMessage(event) {
      if (event.data.cmd) {
        this.newItem.h5p_content_id = event.data.params.contentId;
      }
    },
    selectedType(item) {
      console.log(item);
      //
      this.$set(this.newItem, "type", item.type);
      this.$set(
        this,
        "src",
        config.serverUrl + "/editor?type=" + this.newItem.type
      );
      switch (item.type) {
        case "uploaded_voice_lectures":
          this.accept = "audio/*";
          break;
        case "pdf":
          this.accept = "application/pdf";
          break;
        case "powerpoint_lectures":
          this.accept = ".ppt,.pptx";
          break;
        case "scrom_lectures":
          this.accept = ".zip,.rar";
          break;
        case "video_lectures":
          this.accept = "video/*";
          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>